import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import RequestsPage from './RequestsPage'

export default function index() {
  return (
    <div>
        <Header/>
        <RequestsPage/>
        <Footer/>
    </div>
  )
}
